import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Landing from "@/pages/Landing";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Availability from "@/pages/Availability";
import Templates from "@/pages/Templates";
import Bookings from "@/pages/Bookings";
import PublicBooking from "@/pages/PublicBooking";

const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <Loader2 className="w-7 h-7 animate-spin text-blue-600" />
  </div>
);

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/book/:slug" element={<PublicBooking />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/availability" element={<Protected><Availability /></Protected>} />
      <Route path="/templates" element={<Protected><Templates /></Protected>} />
      <Route path="/bookings" element={<Protected><Bookings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
